var DateTimeLocale = (function () {
    function DateTimeLocale(periods, weekdays, shortWeekdays, months, shortMonths) {
        if (periods === void 0) { periods = DateTimeLocale.Periods; }
        if (weekdays === void 0) { weekdays = DateTimeLocale.Weekdays; }
        if (shortWeekdays === void 0) { shortWeekdays = DateTimeLocale.ShortWeekdays; }
        if (months === void 0) { months = DateTimeLocale.Months; }
        if (shortMonths === void 0) { shortMonths = DateTimeLocale.ShortMonths; }
        this.periods = periods;
        this.weekdays = weekdays;
        this.shortWeekdays = shortWeekdays;
        this.months = months;
        this.shortMonths = shortMonths;
    }
    DateTimeLocale.Periods = [
        'AM',
        'PM',
    ];
    DateTimeLocale.Weekdays = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    DateTimeLocale.ShortWeekdays = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
    ];
    DateTimeLocale.Months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    DateTimeLocale.ShortMonths = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    DateTimeLocale.Default = new DateTimeLocale();
    return DateTimeLocale;
}());
export { DateTimeLocale };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS10aW1lLWxvY2FsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRhdGUtdGltZS1sb2NhbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFPRSx3QkFBWSxPQUF1RCxFQUN2RCxRQUF5RCxFQUN6RCxhQUFtRSxFQUNuRSxNQUFxRCxFQUNyRCxXQUErRDtRQUovRCx3QkFBQSxFQUFBLFVBQWlDLGNBQWMsQ0FBQyxPQUFPO1FBQ3ZELHlCQUFBLEVBQUEsV0FBa0MsY0FBYyxDQUFDLFFBQVE7UUFDekQsOEJBQUEsRUFBQSxnQkFBdUMsY0FBYyxDQUFDLGFBQWE7UUFDbkUsdUJBQUEsRUFBQSxTQUFnQyxjQUFjLENBQUMsTUFBTTtRQUNyRCw0QkFBQSxFQUFBLGNBQXFDLGNBQWMsQ0FBQyxXQUFXO1FBQ3pFLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO1FBQ3ZCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxhQUFhLEdBQUcsYUFBYSxDQUFDO1FBQ25DLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO0lBQ2pDLENBQUM7SUFFdUIsc0JBQU8sR0FBMEI7UUFDdkQsSUFBSTtRQUNKLElBQUk7S0FDTCxDQUFDO0lBQ3NCLHVCQUFRLEdBQTBCO1FBQ3hELFFBQVE7UUFDUixRQUFRO1FBQ1IsU0FBUztRQUNULFdBQVc7UUFDWCxVQUFVO1FBQ1YsUUFBUTtRQUNSLFVBQVU7S0FDWCxDQUFDO0lBQ3NCLDRCQUFhLEdBQTBCO1FBQzdELEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7S0FDTixDQUFDO0lBQ3NCLHFCQUFNLEdBQTBCO1FBQ3RELFNBQVM7UUFDVCxVQUFVO1FBQ1YsT0FBTztRQUNQLE9BQU87UUFDUCxLQUFLO1FBQ0wsTUFBTTtRQUNOLE1BQU07UUFDTixRQUFRO1FBQ1IsV0FBVztRQUNYLFNBQVM7UUFDVCxVQUFVO1FBQ1YsVUFBVTtLQUNYLENBQUM7SUFDc0IsMEJBQVcsR0FBMEI7UUFDM0QsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO1FBQ0wsS0FBSztRQUNMLEtBQUs7UUFDTCxLQUFLO0tBQ04sQ0FBQztJQUVjLHNCQUFPLEdBQW1CLElBQUksY0FBYyxFQUFFLENBQUM7SUFDakUscUJBQUM7Q0FBQSxBQXZFRCxJQXVFQztTQXZFWSxjQUFjIn0=